import { gql } from '@apollo/client';

export const SELECT_LOANS_FOR_DILIGENCE = gql`
  mutation SelectLoansForDiligence($input: SelectDiligenceLoansInput!) {
    selectLoansForDiligence(input: $input)
  }
`;
